import React from 'react';

const PrivacyPolicy = () => {
	return (
		<div className="min-h-screen bg-zinc-900 py-16 px-4 sm:px-6 lg:px-8">
			<div className="max-w-4xl mx-auto">
				<h1 className="text-3xl font-bold text-white mb-8">Privacy Policy</h1>

				<div className="space-y-8 text-slate-300">
					<section>
						<p className="mb-4 italic">Last Updated: December 1, 2024</p>
						<p className="mb-4">
							This Privacy Policy describes how Recovery House Portal ("we," "us," or "our") collects, uses, and protects your information when you use our platform.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
						<p className="mb-4">We collect minimal information necessary to provide our service:</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>Email address used for account creation and login</li>
							<li>Name associated with your email account</li>
							<li>Basic usage data (login times, pages visited)</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
						<p className="mb-4">We use your information only to:</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>Create and manage your account</li>
							<li>Authenticate you when you log in</li>
							<li>Communicate important service updates</li>
							<li>Provide customer support when needed</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">3. Information Security</h2>
						<p className="mb-4">
							We protect your information using standard security measures including secure HTTPS connections and encrypted data storage.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">4. Cookies</h2>
						<p className="mb-4">
							We use essential cookies to keep you logged in and remember your preferences. These are necessary for the website to function properly.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">5. Your Rights</h2>
						<p className="mb-4">You can:</p>
						<ul className="list-disc pl-6 space-y-2 mb-4">
							<li>Request to see what information we have about you</li>
							<li>Update your information</li>
							<li>Delete your account and associated data</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-semibold text-white mb-4">6. Contact Us</h2>
						<p className="mb-4">
							If you have questions about this Privacy Policy, please contact us at{' '}
							<a href="mailto:recoveryhouseplatform@gmail.com" className="text-blue-400 hover:text-blue-300">
								recoveryhouseplatform@gmail.com
							</a>
						</p>
					</section>

					<section className="mt-8 pt-8 border-t border-zinc-700">
						<p className="text-sm text-slate-400">
							By using Recovery House Portal, you agree to this Privacy Policy.
						</p>
					</section>
				</div>
			</div>
		</div>
	);
};

export default PrivacyPolicy;